import type { ProposalState, StateTree } from '@makemydeal/dr-dash-types';

export const getProposalState = (state: StateTree): ProposalState | undefined => {
    return state.proposal;
};

export const proposalListDrawerShown = (state: StateTree) => {
    return getProposalState(state)?.showProposalListDrawer || false;
};

export const createProposalLoading = (state: StateTree) => {
    return getProposalState(state)?.create?.isLoading || false;
};

export const createProposalError = (state: StateTree) => {
    return getProposalState(state)?.create?.isError || false;
};

export const createProposalErrorMessage = (state: StateTree) => {
    return getProposalState(state)?.create?.errorMessage;
};

export const createProposalSuccess = (state: StateTree) => {
    return getProposalState(state)?.create?.isSuccess || false;
};

export const getProposalList = (state: StateTree) => {
    return getProposalState(state)?.list.value || [];
};

export const getProposalsLoading = (state: StateTree) => {
    return getProposalState(state)?.list.isLoading || false;
};

export const getProposalsError = (state: StateTree) => {
    return getProposalState(state)?.list.isError || false;
};

export const getProposalPreview = (state: StateTree) => {
    return getProposalState(state)?.preview.value || '';
};

export const getProposalPreviewLoading = (state: StateTree) => {
    return getProposalState(state)?.preview.isLoading || false;
};

export const getProposalPreviewError = (state: StateTree) => {
    return getProposalState(state)?.preview.isError || false;
};

export const getCreatedProposal = (state: StateTree) => {
    return getProposalState(state)?.create.proposal;
};

export const copyProposalSuccess = (state: StateTree) => {
    return getProposalState(state)?.copy.isSuccess || false;
};

export const copyProposalLoading = (state: StateTree) => {
    return getProposalState(state)?.copy.isLoading || false;
};

export const copyProposalError = (state: StateTree) => {
    return getProposalState(state)?.copy.isError || false;
};

export const deleteProposalSuccess = (state: StateTree) => {
    return getProposalState(state)?.delete.isSuccess || false;
};

export const deleteProposalLoading = (state: StateTree) => {
    return getProposalState(state)?.delete.isLoading || false;
};

export const deleteProposalError = (state: StateTree) => {
    return getProposalState(state)?.delete.isError || false;
};

export const updateProposalSuccess = (state: StateTree) => {
    return getProposalState(state)?.update.isSuccess || false;
};

export const updateProposalLoading = (state: StateTree) => {
    return getProposalState(state)?.update.isLoading || false;
};

export const updateProposalError = (state: StateTree) => {
    return getProposalState(state)?.update.isError || false;
};

export const updateProposalErrorMessage = (state: StateTree) => {
    return getProposalState(state)?.update?.errorMessage;
};

export const getUpdatedProposal = (state: StateTree) => {
    return getProposalState(state)?.update.proposal;
};

export const getCurrentProposal = (state: StateTree) => {
    return getProposalState(state)?.current.proposal;
};

export const getCurrentProposalLoading = (state: StateTree) => {
    return getProposalState(state)?.current.isLoading || false;
};

export const getCurrentProposalError = (state: StateTree) => {
    return getProposalState(state)?.current.isError || false;
};

export const getPrimaryProposalId = (state: StateTree): string | undefined => {
    return getProposalList(state).find((proposal) => proposal.isPrimary)?.id;
};

export const getProposalPaymentRangeConfig = (state: StateTree) => {
    return getCreatedProposal(state)?.displayConfiguration?.paymentRange;
};
